// src/config.js
export const BASE_URL = import.meta.env.VITE_API_URL || 'https://dashboard.shamnet.com.sa/api';
